import { useState } from 'react'
import { DeleteOutlined } from '@mui/icons-material'
import { Button, DialogActions, DialogContent, DialogContentText } from '@mui/material'

import DialogWithTitle from '../../../../components/dialog-with-title'
import useStyles from '../../index.styles'

const RemoveModal = ({ open, setOpen, onRemove }: { open: boolean; setOpen: React.Dispatch<React.SetStateAction<boolean>>; onRemove: () => Promise<void> }) => {
  const classes = useStyles
  const [isRemoving, setIsRemoving] = useState<boolean>(false)

  return (
    <DialogWithTitle title="Remove" open={open} setOpen={setOpen}>
      <DialogContent>
        <DialogContentText sx={classes.dialogText}>You are about to remove the selected folders from this user’s account.</DialogContentText>

        <DialogActions>
          <Button variant="outlined" onClick={() => setOpen(false)}>
            Cancel
          </Button>

          <Button
            variant="contained"
            disabled={isRemoving}
            onClick={async () => {
              setIsRemoving(true)
              await onRemove()
              setIsRemoving(false)
              setOpen(false)
            }}
            startIcon={<DeleteOutlined />}
            color="error"
          >
            Remove
          </Button>
        </DialogActions>
      </DialogContent>
    </DialogWithTitle>
  )
}

export default RemoveModal
